'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const index = require('./index-8d6fcb04.js');

const rgStepperHorizontalStepCss = ":host{display:block}.stepper-selector{padding:80px 0px 10px 0px}";

const RgStepperHorizontalStep = class {
    constructor(hostRef) {
        index.registerInstance(this, hostRef);
        this.rgClick = index.createEvent(this, "rg-click", 7);
        this.isActive = false;
        this.last = false;
        this.height = 0;
        this.showDefaultButton = false;
    }
    enter(scrollIntoView = true) {
        let scrollHeight = this.height;
        // this.contentEl.hidden = false;
        // Render bug with height
        requestAnimationFrame(() => {
            scrollHeight = this.contentWrapperEl.scrollHeight;
        });
        this.height = 0;
        // Give the collapsing element time to collapse
        setTimeout(() => {
            this.isActive && (this.height = scrollHeight || "auto");
            if (scrollIntoView)
                this.scrollIntoView();
            // change height to auto, just incase contents change height
            setTimeout(() => {
                this.height = "auto";
            }, 300);
        }, 0);
    }
    leave() {
        this.height = this.contentWrapperEl.clientHeight;
        setTimeout(function () {
            this.height = 0;
        }, 10);
    }
    scrollIntoView() {
        // this.host.scrollIntoView({ behavior: "smooth" });
    }
    handleClick(e) {
        e.stopPropagation();
        this.stepperEl.stepClick(this.step);
        this.rgClick.emit();
    }
    async show() {
        this.isActive = true;
    }
    async hide() {
        this.isActive = false;
    }
    isActiveChanged() {
        if (this.isActive)
            this.enter(this.stepperEl.loaded);
        else
            this.leave();
    }
    connectedCallback() {
        // assign host stepper el
        this.handleClick = this.handleClick.bind(this);
        var stepperEl = this.host.closest("rg-stepper-horizontal");
        if (!!stepperEl) {
            this.stepperEl = stepperEl;
        }
    }
    convertToUnit(str, unit = "px") {
        if (str == null || str === "") {
            return undefined;
        }
        else if (isNaN(+str)) {
            return String(str);
        }
        else {
            return `${Number(str)}${unit}`;
        }
    }
    render() {
        let wrapperStyle = {
            height: this.convertToUnit(this.height),
        };
        return (index.h(index.Host, null, this.isActive && (index.h("div", { id: `step-content-${this.step}`, class: "stepper-selector", role: "region", "aria-expanded": this.isActive ? "true" : "false", "aria-labelledby": `step-label-${this.step}` }, index.h("div", { ref: (el) => (this.contentWrapperEl = el), class: "step-wrapper", style: wrapperStyle }, index.h("slot", null), index.h("br", null), index.h("br", null), index.h("br", null), !this.last && this.showDefaultButton && (index.h("rg-button", { priority: "secondary", onClick: () => this.stepperEl.stepClick(this.step + 1) }, index.h("button", { onClick: () => this.stepperEl.stepClick(this.step + 1) }, "Continue"))))))));
    }
    get host() { return index.getElement(this); }
    static get watchers() { return {
        "isActive": ["isActiveChanged"]
    }; }
};
RgStepperHorizontalStep.style = rgStepperHorizontalStepCss;

exports.rg_stepper_horizontal_step = RgStepperHorizontalStep;
